// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Extended key-value pairs for truly variable data.
 */
export class TraceKV implements flatbuffers.IUnpackableObject<TraceKVT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TraceKV {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTraceKV(bb: flatbuffers.ByteBuffer, obj?: TraceKV): TraceKV {
    return (obj || new TraceKV()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTraceKV(bb: flatbuffers.ByteBuffer, obj?: TraceKV): TraceKV {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TraceKV()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(): string;
  key(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  key(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  value(): string;
  value(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  value(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startTraceKV(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, keyOffset, 0);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, valueOffset, 0);
  }

  static endTraceKV(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    builder.requiredField(offset, 6); // value
    return offset;
  }

  static createTraceKV(
    builder: flatbuffers.Builder,
    keyOffset: flatbuffers.Offset,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    TraceKV.startTraceKV(builder);
    TraceKV.addKey(builder, keyOffset);
    TraceKV.addValue(builder, valueOffset);
    return TraceKV.endTraceKV(builder);
  }

  unpack(): TraceKVT {
    return new TraceKVT(this.key(), this.value());
  }

  unpackTo(_o: TraceKVT): void {
    _o.key = this.key();
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): TraceKVT {
    const t = new TraceKVT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key();
    }
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class TraceKVT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: string | Uint8Array | null = null,
    public value: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const key = this.key !== null ? builder.createString(this.key!) : 0;
    const value = this.value !== null ? builder.createString(this.value!) : 0;

    return TraceKV.createTraceKV(builder, key, value);
  }

  clone(): TraceKVT {
    const obj = new TraceKVT();
    obj.key = this.key;
    obj.value = this.value;
    return obj;
  }

  equals(other: TraceKVT): boolean {
    if (this.key !== other.key) return false;
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyTraceKV(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "key");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "value");
  } finally {
    verifier.popDepth();
  }
}
